import { definitions } from '@luxuryescapes/contract-business'

type ServerAccountSummary = NonNullable<definitions['accountReadByCustomerIdResponseSchema']['accountSummary']>

function mapLoyaltyLinkedCreditAccount(response: ServerAccountSummary | null): App.LoyaltyLinkedCreditAccount | undefined {
  if (!response) return undefined

  return {
    tier: response.tier,
  }
}

export default mapLoyaltyLinkedCreditAccount
